export class LayoutService {
  constructor($rootScope) {
    this.$rootScope = $rootScope;
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (this.isFirefox) {
      window.onbeforeprint = () => {
        this.beforePrint();
      };
      window.onafterprint = () => {
        this.afterPrint();
      }
    } else {
      this.mediaQueryPrint = window.matchMedia('print');
      this.mediaQueryPrint.addListener(() => this.printHandler());
    }
  }

  beforePrint() {
    this.isPrint = true;
    this.$rootScope.$digest();
    this.$rootScope.$broadcast('splitterChanged');
    this.$rootScope.$broadcast('beforePrint');
    //console.log('before print');
  }

  afterPrint() {
    this.isPrint = false;
    this.$rootScope.$digest();
    this.$rootScope.$broadcast('splitterChanged');
    this.$rootScope.$broadcast('afterPrint');
    //console.log('after print');
  }

  printHandler() {
    if (this.mediaQueryPrint.matches) {
      this.beforePrint();
    } else {
      this.afterPrint();
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/layout.service.js